// extracted by mini-css-extract-plugin
module.exports = {"mb_sm":"style_mb_sm__yzd_U","icon":"style_icon__Sh56k","value":"style_value__Rwsd7"};